"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionLabel = void 0;
var ActionLabel;
(function (ActionLabel) {
    ActionLabel["ACTIVE"] = "active";
    ActionLabel["PASSED"] = "passed";
    ActionLabel["NEXT"] = "next";
    ActionLabel["NONE"] = "none";
    ActionLabel["DRAFTING"] = "drafting";
    ActionLabel["RESEARCHING"] = "researching";
})(ActionLabel = exports.ActionLabel || (exports.ActionLabel = {}));
//# sourceMappingURL=ActionLabel.js.map